import { render, staticRenderFns } from "./AnimationHeight.vue?vue&type=template&id=1064773e&scoped=true&"
import script from "./AnimationHeight.vue?vue&type=script&lang=js&"
export * from "./AnimationHeight.vue?vue&type=script&lang=js&"
import style0 from "./animation-height.scss?vue&type=style&index=0&id=1064773e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1064773e",
  null
  
)

export default component.exports